import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=ffd623bc&scoped=true&"
import script from "./AssignmentList.vue?vue&type=script&lang=js&"
export * from "./AssignmentList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentList.vue?vue&type=style&index=0&id=ffd623bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd623bc",
  null
  
)

export default component.exports